export const CAMPAIGN_STATUS_ACTIVE = "ACTIVE"
export const ADGROUP_STATUS_ACTIVE = "ACTIVE"
